import { createFileRoute } from "@tanstack/react-router";
import BlogPostPage from "@/pages/site/BlogPostPage";
import { wpPostsQueryOptions } from "./blog.index";

export const Route = createFileRoute("/blog/$slug")({
  loader: ({ context }) => context.queryClient.ensureQueryData(wpPostsQueryOptions),
  component: () => <BlogPostPage />,
});
